import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

// project-imports
import { APP_DEFAULT_PATH } from 'config';
import { useBuyNowLink } from 'hooks/buyNowLink';
import useAuth from 'hooks/useAuth';

// types
import { GuardProps } from 'types/auth';

// ==============================|| GUEST GUARD ||============================== //

export default function GuestGuard({ children }: GuardProps) {
  const { isLoggedIn } = useAuth();
  const { getQueryParams } = useBuyNowLink();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (isLoggedIn) {
      if (location.pathname.startsWith("/auth")) {
        // DO nothing 
        // Allow reset password / auth code paths
      } else {
        navigate(location?.state?.from ? location?.state?.from : APP_DEFAULT_PATH + getQueryParams, {
          state: { from: '' },
          replace: true
        });

      }

    }
  }, [isLoggedIn, navigate, location, getQueryParams]);

  return children;
}
